import * as tslib_1 from "tslib";
import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
export var defaultMailSearchStore = {
    fromDate: null,
    includeAttachments: false,
    initialSearchScope: null,
    isSearchHistoryDirty: false,
    legacySuggestions: new ObservableMap({}),
    previousNode: null,
    refinersVisible: false,
    searchBoxWidth: null,
    searchNumber: 0,
    staticSearchScope: null,
    staticSearchScopeList: null,
    toDate: null,
};
var initialStore = tslib_1.__assign({}, defaultMailSearchStore);
export var getStore = createStore('mailSearchStore', initialStore);
var store = getStore();
export default store;
//# sourceMappingURL=store.js.map